import PropTypes from 'prop-types'
import React from 'react'
import ReactSVG from 'react-svg'
import { formatPhone } from 'SRC/modules/layout/Sidebar/AdsList/functions/functions'

export const CallButton = ({ phone }) => (
  <a className='oglasi-call-button' href={`tel: +${phone}`}>
    <span>
      <ReactSVG src='/icons/telefon.svg' beforeInjection={svg => {
        svg.setAttribute('style', 'width: 30px; height: 30px;')
      }} wrapper='span' className='oglasi-call-button-icon' />
    </span>
    <p>Pozovi prodavca</p>
  </a>
)

CallButton.propTypes = {
  phone: PropTypes.string.isRequired
}
